export default __webpack_public_path__ + "static/media/myspacerevival.08709614.jpg";